'use client'

import React, { FC, ReactElement } from 'react'
import styles from './WalletBalance.module.css'
import BitcoinIcon from '@/icons/bitcoin-filled'

import Wallet from '@/utils/wallet'
import useWalletBalance from '@/utils/hooks/useWalletBalance'
import useSatoshiPriceUSD from '@/utils/hooks/useSatoshiPriceUSD'
import WalletActions from '../wallet-actions'
import SendReceive from '../send-receive'
import TopUpButtonGradient from '@/components/top-up-button-gradient'
import WalletCoinCard from '../wallet-coin-card'
import classNames from 'classnames'
import WalletBalanceXverse from './wallet-balance-xverse'
import useSatoshiPrice from '@/utils/hooks/useSatoshiPrice'
import Button from '@/components/button'
import WalletBalanceDisplay from '../wallet-balance-display'
import { NETWORK, NETWORK_NAME } from '@/utils/constants'
import featureFlags from '@/utils/feature-flags'

const WalletBalance: FC<{
	className?: string
	balanceClassName?: string
	value?: number
	label?: string
	confirmed?: boolean
	toggleSignMessage: () => void
	toggleSendCoin: () => void
	toggleRecieveCoin: () => void
	toggleTopupModal: () => void
}> = (props): ReactElement => {
	const { toggleSignMessage, toggleRecieveCoin, toggleSendCoin, toggleTopupModal } = props
	const { data, isLoading } = useWalletBalance()

	const balance = useSatoshiPrice(data?.confirmed_balance)
	const [balanceUSD, _isLoadingBalanceUSD] = useSatoshiPriceUSD(data?.confirmed_balance)
	const [_incomingBalanceUSD, _isLoadingIncomingBalanceUSD] = useSatoshiPriceUSD(
		data?.unconfirmed_balance
	)

	return (
		<div className={styles.root}>
			<div className={styles.walletHeader}>
				<WalletActions toggleSignMessage={toggleSignMessage} />
			</div>
			<div className={styles.walletBalanceContainer}>
				<p className={classNames(styles.balanceLabel, 'text-sm', 'regular')}>{NETWORK} Balance</p>
				<WalletBalanceDisplay
					confirmedSatoshis={data?.confirmed_balance}
					unconfirmedSatoshis={data?.unconfirmed_balance}
					isLoading={isLoading}
				/>
			</div>
			{Wallet.provider.capabilities.includes('payments-wallet') && <WalletBalanceXverse />}
			<div className={styles.actions}>
				{Wallet.type() === 'ordinalswallet' ? (
					<>
						<SendReceive onClickSend={toggleSendCoin} onClickReceive={toggleRecieveCoin} />
						{!featureFlags('app::disable_trade') && (
							<Button
								background="transparent"
								onClick={toggleTopupModal}
								className={styles.topupButton}
								size="large"
							>
								<BitcoinIcon width={22} className={styles.icon} />

								<span className={classNames(styles.topupLabel, 'text-md', 'semibold')}>
									Trade {NETWORK_NAME.toLowerCase()}
								</span>
							</Button>
						)}
					</>
				) : (
					<TopUpButtonGradient onClick={toggleTopupModal} className={styles.moonpay} />
				)}
			</div>
			<WalletCoinCard
				tickerIcon={<BitcoinIcon className={styles.bitcoinTickerIcon} />}
				ticker={NETWORK}
				balanceCoin={data?.confirmed_balance > 0 ? balance : '0.00000000'}
				balanceUsd={balanceUSD}
				isLoading={isLoading}
			/>
		</div>
	)
}

export default WalletBalance
